export default __webpack_public_path__ + "static/media/payNowRedirectIcon.327306b0.svg";